export enum UploadType {
  single = 0,
  zone = 1,
}
